import { render, staticRenderFns } from "./OpenClawMobile.vue?vue&type=template&id=1f66b08d&scoped=true"
import script from "./OpenClawMobile.vue?vue&type=script&lang=js"
export * from "./OpenClawMobile.vue?vue&type=script&lang=js"
import style0 from "./OpenClawMobile.vue?vue&type=style&index=0&id=1f66b08d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66b08d",
  null
  
)

export default component.exports